const RepetitionInterval = {
    NEVER : 'RepetitionInterval.NEVER',
    DAILY : 'RepetitionInterval.DAILY',
    WEEKLY : 'RepetitionInterval.WEEKLY',
    MONTHLY : 'RepetitionInterval.MONTHLY',
    HALFYEARLY : 'RepetitionInterval.HALFYEARLY',
    YEARLY : 'RepetitionInterval.YEARLY',
};

export default RepetitionInterval;